/* Agora Low Quality Video Stream
 * - Equivalent of 180p_1
 */
export const VIDEO_LOW_STREAM_CONFIG = {
  width: 320,
  height: 180,
  framerate: 15,
  bitrate: 140
};

/*
 * Agora setStreamFallbackOption fallbackType
 * - Under poor network, the SDK may subscribe to the low-quality video stream (of lower resolution and lower bitrate) first,
 * - but if the network still does not allow displaying the video, the SDK will receive audio only
 */
export const AUDIO_ONLY_FALLBACK = 2;

/*
 * Agora Network Quality
 * - 0: The quality is unknown.
 * - 1: The quality is excellent.
 * - 2: The quality is good, but the bitrate is less than optimal.
 * - 3: Users experience slightly impaired communication.
 * - 4: Users can communicate with each other, but not very smoothly.
 * - 5: The quality is so poor that users can barely communicate.
 */
export const NETWORK_QUALITY = {
  unknown: 0,
  excellent: 1,
  good: 2,
  fair: 3,
  poor: 4,
  bad: 5
};

export const BANDWIDTH_THRESHOLDS = {
  excellent: {
    profile: '360p_4',
    label: 'excellent',
    value: NETWORK_QUALITY.excellent
  },
  moderate: {
    profile: '180p_1',
    label: 'moderate',
    value: NETWORK_QUALITY.poor,
  },
  poor: {
    profile: '180p_1',
    label: 'poor',
    value: NETWORK_QUALITY.bad
  }
};

/*
 * Agora stream type
 * - 0: High-bitrate, high-resolution video stream.
 * - 1: Low-bitrate, low-resolution video stream.
 */
export const STREAM_TYPE = {
  high: 0,
  low: 1
};

/*
* Minimum buffer limit to activate switching to another stream quality
*/
export const BUFFER_SWITCH_MIN_COUNT = 8;

/*
* Minimum buffer limit to activate audio only mode
*/

export const BUFFER_ACTIVATE_AUDIO_ONLY = 2

/*
* Join timeout threshold in milliseconds.
* If rtc.join() takes longer than this, a proactive warning is logged.
*/
export const JOIN_TIMEOUT_THRESHOLD_MS = 20000;

/*
* Minimum buffer limit to switch from audio only to better quality
* Half faster than the normal BUFFER_SWITCH_MIN_COUNT
* This is so that the user won't need to wait longer for video to be enabled again
*/
export const BUFFER_DEACTIVATE_AUDIO_ONLY = 4;
